import { Button, Form, Offcanvas } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSettings } from "context/SettingsContext";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useWarehouse } from "../context/WarehouseProvider";
import Select from "react-select";
import { selectStylesDark, selectStylesLigth } from "utils/helpers/structs/selectStyles";
import { useTheme } from "context/ThemeContext";
import { CatalogCategoryFilter } from "modules/product";

interface Props {
    wId: number;
    show: boolean;
    setShow: (show: boolean) => void;
    setPrevFilter: Dispatch<SetStateAction<Record<string, any> | null>>
    prevFilter: Record<string, any> | null;
}


const OffFilter = ({show, setShow, setPrevFilter, prevFilter}: Props) => {

    const { t } = useTranslation(['Warehouses', 'common']);
    const { setStockFilter } = useWarehouse();
    const { settings } = useSettings();
    const { darkTheme } = useTheme();
    const [ vendorsOptions, setVendorsOptions ] = useState([]);
    const [ selectTheme, setSelectTheme ] = useState(darkTheme?selectStylesDark:selectStylesLigth);

    const handleHide = () => {
        setShow(false);
    }

    useEffect(()=>{
        setVendorsOptions(settings.DIRS.Vendor?.map(v=>({value:v.ID.toString(), label:v.vendorName})));
    },[settings]);



    useEffect(()=>{
        setSelectTheme(darkTheme?selectStylesDark:selectStylesLigth);
    },[darkTheme])

    return (
        <Offcanvas
            show={show!==false}
            onHide={handleHide}
            placement="end">
            <Offcanvas.Header closeButton className="border-bottom">
                <Offcanvas.Title>{t('filter.title')}</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="position-relative pb-0 d-flex flex-column px-0">
                <div className="off-filter-form d-flex flex-column h-100">
                    <div className="off-filter-content px-3">
                        <CatalogCategoryFilter
                            embedded
                            kind="product"
                            filterCategoryId={prevFilter?.categoryId ? Number(prevFilter.categoryId) : null}
                            setFilterCategoryId={(id) =>
                                setPrevFilter((prev) => ({ ...prev, categoryId: id }))
                            }
                        />

                        <Form.Group className="mb-3">
                            <label className="form-label text-muted">{t('filter.labelVendors')}</label>
                            <Select
                                options={vendorsOptions}
                                styles={{
                                    ...selectTheme,
                                    control: (base, state) => ({
                                    ...base,
                                    ...(selectTheme.control ? selectTheme.control(base, state) : {}),
                                    }),
                                }}
                                value={
                                    vendorsOptions.filter(v=>prevFilter?.vendors?.includes(v.value))
                                }
                                onChange={(value)=>{
                                    const v = value.map(v=>v.value);
                                    setPrevFilter({...prevFilter, vendors: v})}
                                }
                                isMulti={true}
                                placeholder={t('filter.labelSetVendors')} />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <div className="form-check form-switch mb-3" >
                            <input type="checkbox" className="form-check-input" role="switch" id="ex-switch-payment"
                                checked={Boolean(prevFilter?.showAll)}
                                onChange={(e)=>setPrevFilter({...prevFilter, showAll: e.target.checked})}/>
                            <label htmlFor="ex-switch-payment" className="form-check-label">{t('filter.labelShowAll')}</label>
                        </div>
                        </Form.Group>
                    </div>

                    <div className="p-3 offcanvas-footer off-filter-footer">
                        <div className="d-flex justify-content-end gap-2">
                            <Button
                                variant="secondary"
                                onClick={()=>{
                                    setPrevFilter(null);
                                    setStockFilter(null);
                                    handleHide()
                                }}>
                                    {t('common:buttons.reset')}</Button>
                            <Button
                                variant="info"
                                className="min100px"
                                onClick={()=>{
                                    setStockFilter(prevFilter)
                                    handleHide()
                                }}>
                                    {t('common:buttons.apply')}</Button>
                        </div>
                    </div>
                </div>
            </Offcanvas.Body>
        </Offcanvas>
    )
}

export default OffFilter;
